import { atom } from "jotai";

export const importFromTextDialogAtom = atom(false);
export const generationDialogAtom = atom(false);
export const metadataEditorDialogAtom = atom(false);
export const settingsDialogAtom = atom(false);
export const settingsTabAtom = atom("common");
export const latencyTestDialogAtom = atom(false);
export const splitWordDialogAtom = atom(false);
export const replaceWordDialogAtom = atom(false);
export const timeShiftDialogAtom = atom(false);
export const distributeRomanizationDialogAtom = atom(false);
export const confirmDialogAtom = atom<{
	open: boolean;
	title: string;
	description: string;
	onConfirm?: () => void;
	/** When true, only an OK button is shown (for alerts). */
	alertOnly?: boolean;
}>({
	open: false,
	title: "",
	description: "",
});
export const historyRestoreDialogAtom = atom(false);
export const importFromLRCLIBDialogAtom = atom(false);
export const importFromAppleMusicDialogAtom = atom(false);
export const importFromUtanetDialogAtom = atom(false);
export const importFromJoysoundDialogAtom = atom(false);
export const loadAudioFromSpotifyDialogAtom = atom(false);
export const uploadToTtmlDbDialogAtom = atom(false);
/** 特急 API (off_vocal_maker) へ同期歌詞を納品するダイアログ。 */
export const deliverToExpressDialogAtom = atom(false);
/** 単語結合時に、同じ並びの他の箇所にも適用するかを確認するダイアログ。 */
export const mergeWordsDialogAtom = atom<{
	open: boolean;
	lineIndex: number;
	wordIds: Set<string>;
	pattern: string[];
	otherCount: number;
}>({
	open: false,
	lineIndex: -1,
	wordIds: new Set<string>(),
	pattern: [],
	otherCount: 0,
});
